import { Injectable } from '@angular/core';
import { DocumentNode } from 'graphql';
import gql from 'graphql-tag';

@Injectable({
  providedIn: 'root'
})
export class Mutations {
  createUser(): DocumentNode {
    return gql`
      mutation createUser($input: UserInput!) {
        createUser(input: $input) {
          id
          name
          email
          avatarUrl
        }
      }
    `;
  }

  updateUser(): DocumentNode {
    return gql`
      mutation updateUser($id: ID!, $input: UserInput!) {
        updateUser(id: $id, input: $input) {
          id
          name
          email
          avatarUrl
        }
      }
    `;
  }

  archiveUser(): DocumentNode {
    return gql`
      mutation archiveUser($id: ID!) {
        archiveUser(id: $id) {
          id
          archived
        }
      }
    `;
  }

  unarchiveUser(): DocumentNode {
    return gql`
      mutation unarchiveUser($id: ID!) {
        unarchiveUser(id: $id) {
          id
          archived
        }
      }
    `;
  }
}
